<template>
    <CCard v-if="!item.ad" style="background-color: #4fc3f7">
        <CCardBody>
            <CRow>
                <div class="col-sm-4" style="text-align: center">
                    <img src="@/assets/images/logo_nomina.png" width="150" />
                </div>
                <div class="col-sm-6">
                    <CRow>
                        <div class="col-sm-10">
                            <label class="label">
                                {{item.description}}
                            </label>
                        </div>
                    </CRow>
                    <CRow>
                        <div class="col-sm-10">
                            <label class="label">
                                {{item.user.name}}
                            </label>
                        </div>
                    </CRow>
                </div>
                <a class="col-sm-12">
                    <div class="btn-detail" @click="onShowItem(item)"> 
                        {{ $t('requests.detail') }}
                    </div>
                </a>
            </CRow>
        </CCardBody>
    </CCard>
    <CCard v-else>
        <CCardBody>
            <a :href="item.advertisement.url">
                <img :src="item.advertisement.path" style="height: 100%; width: 100%; object-fit: cover;"/>
            </a>
        </CCardBody>
    </CCard>
</template>

<script>
import store from '../../../store'

export default {
    name: "ChargeItem",
    props: ['item'],
    computed: {
        backgroundColor() {
            let self = this;

            if (self.item.is_demo && store.state.configuration.configuration.color_activas != null) {
                return "#"+store.state.configuration.configuration.color_activas;
            } else {
                return self.item.type_vehicle.color;
            }
        }
    },
    methods: {
        onShowItem() {
            this.$emit('onShowItem', this.item);
        }
    }
}
</script>
